/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */

/*
 * @Description:
 * @Date: 2019-01-15 19:30:59
 */
import Vue from 'vue';
import App from './App';
import FastClick from 'fastclick';
import router from './router/index';
import RouterGuide from './router/guide';
import plugin from '@/plugin/index';
import store from './store/index';
import * as filters from './filters/';
import './assets/css/reset.css';
import './assets/js/flexible.js';
import './filters/index.js';
import './assets/css/animate.css';
import { sync } from 'vuex-router-sync';
import vant from '@/config/vant.js';
import vueSwiper from 'vue-awesome-swiper';
import vueJsonp from 'vue-jsonp';
import Xrk from 'xrk-components'; // import 'vue2-animate/dist/vue2-animate.min.css'

import VuxConfig from './public/VuxConfig';
sync(store, router); // done. Returns an unsync callback fn

Vue.config.productionTip = false;
FastClick.attach(document.body);

try {
  //定义域名
  document.domain = /yxvzb\.com/.test(location.href) ? 'yxvzb.com' : 'jimijiayuan.cn'; //important
} catch (e) {
  console.error('document.domain 与当前有误');
}
/*
vux工具引入时会导致build打入全部VUX 解决方案1 写入路径  2 在模块中引入 在把模块引入main
import AjaxPlugin  from 'vux/src/plugins/ajax'
import WechatPlugin  from 'vux/src/plugins/wechat'

Vue.use(AjaxPlugin) //Vue.http
Vue.use(WechatPlugin) //Vue.wechat

END*/
//Vue.use(VueJsonp)


Vue.use(VuxConfig);
Vue.use(plugin);
Vue.use(vant); //初始化神测

Vue.prototype.$sa.init();
Vue.use(RouterGuide); // window.eventBus = new Vue()

Object.keys(filters).forEach(function (k) {
  return Vue.filter(k, filters[k]);
}); // 注册过滤器
//检测是否小程序打开

function isXCX() {
  if (window.__wxjs_environment === 'miniprogram') {
    store.commit('IS_XCX', true);
  }
}

isXCX();
/* eslint-disable no-new */

new Vue({
  router: router,
  store: store,
  render: function render(h) {
    return h(App);
  }
}).$mount('#app-box');